import { render, staticRenderFns } from "./VeJwXkjhRecycleBin.vue?vue&type=template&id=b5d12de8"
import script from "./VeJwXkjhRecycleBin.vue?vue&type=script&lang=js"
export * from "./VeJwXkjhRecycleBin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports